<template>
	<div class="product-detail">
		<div v-if="product" class="detail-content">
			<el-descriptions title="商品详细信息" :column="2" border>
				<el-descriptions-item label="商品编码">{{ product.productCode }}</el-descriptions-item>
				<el-descriptions-item label="商品名称">{{ product.productName }}</el-descriptions-item>
				<el-descriptions-item label="规格">{{ product.specifications }}</el-descriptions-item>
				<el-descriptions-item label="分类">{{ getCategoryText(product.category) }}</el-descriptions-item>
				<el-descriptions-item label="单位">{{ product.unit }}</el-descriptions-item>
				<el-descriptions-item label="单价">¥{{ product.unitPrice.toFixed(2) }}</el-descriptions-item>
				<el-descriptions-item label="当前库存">{{ product.currentStock }}</el-descriptions-item>
				<el-descriptions-item label="盘点数量">{{ product.inventoryCount }}</el-descriptions-item>
				<el-descriptions-item label="差异数量">
					<span :class="getDifferenceClass(product.difference)">
						{{ product.difference > 0 ? '+' : '' }}{{ product.difference }}
					</span>
				</el-descriptions-item>
				<el-descriptions-item label="批号">{{ product.batchNumber }}</el-descriptions-item>
				<el-descriptions-item label="生产日期">{{ formatDate(product.productionDate) }}</el-descriptions-item>
				<el-descriptions-item label="有效期">{{ formatDate(product.expiryDate) }}</el-descriptions-item>
				<el-descriptions-item label="生产厂家" :span="2">{{ product.manufacturer }}</el-descriptions-item>
				<el-descriptions-item label="备注" :span="2">
					<el-input type="textarea" :rows="2" v-model="product.remark" placeholder="请输入备注">
					</el-input>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ProductDetail',
		props: {
			product: Object
		},
		methods: {
			getCategoryText(category) {
				const map = {
					'western': '西药',
					'chinese': '中药',
					'medical': '医疗器械'
				}
				return map[category] || category
			},
			getDifferenceClass(difference) {
				if (difference > 0) return 'positive-diff'
				if (difference < 0) return 'negative-diff'
				return 'no-diff'
			},
			formatDate(date) {
				if (!date) return ''
				const d = new Date(date)
				return d.toLocaleDateString()
			}
		}
	}
</script>